import React from 'react'
import { Box, Typography } from '@mui/material'
import palette from '../../../../theme/palette'
import { ATTRIBUTABLE, OWNERS } from '../constants'
import { fmtHours } from '../eddBreachUtils'

/** "Who held this shipment": stacked bar of hours per owner (spec §12.2). Renders nothing when nobody held it. */
export default function HoldSplitBar({ split }) {
  if (!split) return null
  const total = ATTRIBUTABLE.reduce((s, k) => s + (split[k] || 0), 0)
  if (!total) return null
  return (
    <Box>
      <Box sx={{ display: 'flex', height: 8, borderRadius: 4, overflow: 'hidden', bgcolor: palette.grey[200] }}>
        {ATTRIBUTABLE.map((k) => split[k] > 0 && (
          <Box key={k} sx={{ width: `${(split[k] / total) * 100}%`, bgcolor: OWNERS[k].color }} />
        ))}
      </Box>
      <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.5 }}>
        {ATTRIBUTABLE.map((k) => `${OWNERS[k].short} ${fmtHours(split[k])}`).join(' · ')}
      </Typography>
    </Box>
  )
}
